module.exports = __webpack_public_path__ + "img/title3.6144ad15.png";